/**
 * bh-text-picker.js — browse the texts other cakes carry and drop one into the
 * message field. Instagram parity: the design stays, only the text changes.
 *
 * Data comes from templates/collection.cake-texts.liquid over the live catalog:
 *   /collections/all?view=cake-texts&sort_by=best-selling[&filter…][&page=N]
 * There is no generated text file — a newly uploaded product with a
 * bakehunters.preset_message appears here with zero rebuild.
 *
 * Open/close/ESC/drag-to-dismiss are the shared bh-drawer's job (markup contract).
 *
 * The whole set loads on open (page 1 first, the rest in parallel), so the count is a
 * real total and search covers every text, not just the first page.
 */
(function () {
  const sheet = document.getElementById('BhTextPicker');
  if (!sheet) return;

  const el = {
    list: sheet.querySelector('[data-bhtp-list]'),
    facets: sheet.querySelector('[data-bhtp-facets]'),
    facetsInner: sheet.querySelector('[data-bhtp-facets-inner]'),
    filterBtn: sheet.querySelector('[data-bhtp-filter]'),
    badge: sheet.querySelector('[data-bhtp-badge]'),
    search: sheet.querySelector('[data-bhtp-search]'),
    clear: sheet.querySelector('[data-bhtp-clear]'),
    count: sheet.querySelector('[data-bhtp-count]'),
    status: sheet.querySelector('[data-bhtp-status]'),
    body: sheet.querySelector('.bh-sheet__body'),
  };
  const L = sheet.dataset;
  const input = document.getElementById('CakeMessage');

  // texts keyed by lowercase so "Happy Birthday" and "happy birthday" collapse to one
  const state = { texts: new Map(), designs: 0, active: new Map(), loading: false, q: '' };

  // On a preset design, start filtered to that design's own occasion + audience
  // (bh-text-picker.liquid writes them). The chips render pressed and can be cleared.
  try {
    const preset = JSON.parse(sheet.dataset.presetFilters || '{}');
    Object.entries(preset).forEach(([param, values]) => {
      if (Array.isArray(values) && values.length) state.active.set(param, new Set(values));
    });
  } catch (e) { /* malformed attribute: open unfiltered */ }

  const url = (page) => {
    const u = new URL(sheet.dataset.endpoint, window.location.origin);
    state.active.forEach((values, param) => values.forEach((v) => u.searchParams.append(param, v)));
    if (page > 1) u.searchParams.set('page', page);
    return u.toString();
  };

  // The limit moves with size + shape, so read it fresh every render.
  const limit = () => parseInt(input && input.getAttribute('maxlength'), 10) || 0;
  const activeCount = () => [...state.active.values()].reduce((n, s) => n + s.size, 0);

  function renderFacets(filters) {
    if (!filters || !filters.length || el.facetsInner.childElementCount) return;
    filters.forEach((f, i) => {
      const row = document.createElement('div');
      row.className = 'bhtp-facet';
      const labelId = 'bhtpFacet' + i;
      const label = document.createElement('span');
      label.className = 'bhtp-facet__label';
      label.id = labelId;
      label.textContent = f.label;
      row.appendChild(label);
      const chips = document.createElement('div');
      // past ~8 values, wrapping eats the sheet — switch that facet to the two-row rail
      const rail = f.values.length > 8;
      chips.className = 'bhtp-chips' + (rail ? ' bhtp-chips--rail' : '');
      let target = chips;
      if (rail) {
        target = document.createElement('div');
        target.className = 'bhtp-chips__row';
        const second = document.createElement('div');
        second.className = 'bhtp-chips__row';
        chips.append(target, second);
      }
      // so a screen reader announces "Повод, group" before the chips
      chips.setAttribute('role', 'group');
      chips.setAttribute('aria-labelledby', labelId);
      // Pre-selected chips first: in a long scrolling rail an active chip could otherwise sit
      // off-screen, and the filter would look like it wasn't applied.
      const on = state.active.get(f.param) || new Set();
      [...f.values].sort((a, b) => on.has(b.value) - on.has(a.value)).forEach((v) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bhtp-chip';
        b.textContent = v.label;
        b.setAttribute('aria-pressed', String(on.has(v.value)));
        b.addEventListener('click', () => toggle(f.param, v.value, b));
        target.appendChild(b);
      });
      row.appendChild(chips);
      el.facetsInner.appendChild(row);
    });
  }

  function toggle(param, value, btn) {
    const on = btn.getAttribute('aria-pressed') === 'true';
    const set = state.active.get(param) || new Set();
    if (on) set.delete(value);
    else set.add(value);
    if (set.size) state.active.set(param, set);
    else state.active.delete(param);
    btn.setAttribute('aria-pressed', String(!on));
    updateBadge();
    state.texts.clear();
    el.list.innerHTML = '';
    load();
  }

  function pick(text) {
    if (!input) return;
    input.value = text;
    // The configurator owns message state + the character counter; an input event
    // is how every other control talks to it.
    input.dispatchEvent(new Event('input', { bubbles: true }));
    sheet.close();
    input.focus();
  }

  function render() {
    const max = limit();
    const q = state.q.trim().toLowerCase();
    const rows = [...state.texts.values()].filter((t) => !q || t.toLowerCase().includes(q));

    el.list.innerHTML = '';
    rows.forEach((t) => {
      const tooLong = max > 0 && t.length > max;
      const li = document.createElement('li');
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'bhtp-item' + (tooLong ? ' is-long' : '');
      b.textContent = t;
      if (tooLong) {
        b.disabled = true;
        const note = document.createElement('span');
        note.className = 'bhtp-item__note';
        note.textContent = L.lToolong;
        b.appendChild(note);
      } else {
        b.addEventListener('click', () => pick(t));
      }
      li.appendChild(b);
      el.list.appendChild(li);
    });

    // "25 надписа" alone read as "there are only 25" — say what they were drawn from.
    el.count.textContent = state.texts.size
      ? L.lCount.replace('__n__', state.texts.size).replace('__d__', state.designs)
      : '';
    el.status.textContent = rows.length || state.loading ? '' : L.lEmpty;
  }

  const absorb = (texts) =>
    texts.forEach((t) => {
      const key = t.toLowerCase();
      if (!state.texts.has(key)) state.texts.set(key, t);
    });

  async function page(n) {
    // No Accept: application/json — the endpoint is a Liquid TEMPLATE, and Shopify
    // content-negotiates a storefront URL asked for JSON into an empty 404.
    const res = await fetch(url(n));
    if (!res.ok) throw new Error(res.status);
    return res.json();
  }

  // Page 1 paints immediately, the rest arrive together. Loading page-by-page on scroll
  // made the header count tick upward (25 → 66 → 105…), which reads as "this is all there
  // is" and then silently contradicts itself. The whole set is ~350 strings — cheap enough
  // to hold, and it makes the count honest and the search cover the real catalogue.
  async function load() {
    if (state.loading) return;
    state.loading = true;
    el.status.textContent = '…';
    try {
      const first = await page(1);
      state.designs = first.products;
      absorb(first.texts);
      renderFacets(first.filters);
      render();
      if (first.pages > 1) {
        const rest = await Promise.all(
          Array.from({ length: first.pages - 1 }, (_, i) => page(i + 2).catch(() => null))
        );
        rest.filter(Boolean).forEach((d) => absorb(d.texts));
      }
      state.loading = false;
      render();
    } catch (e) {
      state.loading = false;
      el.status.textContent = L.lError;
    }
  }

  // Split each rail's chips so both rows end at roughly the same x. Runs on first reveal,
  // not at build time: the panel is [hidden] until then, so nothing has a width to measure.
  let balanced = false;
  function balanceRails() {
    el.facets.querySelectorAll('.bhtp-chips--rail').forEach((rail) => {
      const rows = rail.querySelectorAll('.bhtp-chips__row');
      if (rows.length !== 2) return;
      const chips = [...rows[0].children, ...rows[1].children];
      rows[0].append(...chips);
      const widths = chips.map((c) => c.offsetWidth + 6);
      const half = widths.reduce((a, b) => a + b, 0) / 2;
      let run = 0;
      let i = 0;
      while (i < chips.length - 1 && run + widths[i] <= half) {
        run += widths[i];
        i += 1;
      }
      rows[1].append(...chips.slice(Math.max(1, i)));
    });
    balanced = true;
  }

  function updateBadge() {
    const n = activeCount();
    el.badge.hidden = n === 0;
    el.badge.textContent = n;
  }
  updateBadge();

  el.filterBtn.addEventListener('click', () => {
    const open = el.filterBtn.getAttribute('aria-expanded') === 'true';
    el.filterBtn.setAttribute('aria-expanded', String(!open));
    if (!open && !balanced) balanceRails();
    el.facets.classList.toggle('is-open', !open);
  });

  el.search.addEventListener('input', (e) => {
    state.q = e.target.value;
    el.clear.hidden = !state.q;
    render();
  });
  el.clear.addEventListener('click', () => {
    el.search.value = '';
    state.q = '';
    el.clear.hidden = true;
    render();
    el.search.focus();
  });

  // Load on first open, re-render on every open (the size limit may have changed).
  document.querySelectorAll('[aria-controls="BhTextPicker"]').forEach((t) =>
    t.addEventListener('click', () => (state.texts.size ? render() : load()))
  );
})();
